import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=0a0efd4c&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=js&"
export * from "./CategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0efd4c",
  null
  
)

export default component.exports